// src/components/cart/CartSummary.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';

const CartSummary = () => {
  const { cart } = useCart();
  const subtotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const shipping = subtotal > 50 ? 0 : 8.99;
  const total = subtotal + shipping;

  return (
    <div className="cart-summary">
      <h2 className="summary-title">Order Summary</h2>

      <div className="summary-line">
        <span>Subtotal</span>
        <span>${subtotal.toFixed(2)}</span>
      </div>

      <div className="summary-line">
        <span>Shipping</span>
        <span>{shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}</span>
      </div>

      {subtotal > 50 && (
        <p className="free-shipping-note">🎉 Free shipping applied!</p>
      )}

      <div className="summary-total">
        <strong>Total</strong>
        <strong>${total.toFixed(2)} CAD</strong>
      </div>

      <Link to="/checkout" className="checkout-btn">
        Proceed to Checkout
      </Link>
    </div>
  );
};

export default CartSummary;